import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
var api__createArib = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(postId, workInfo, order_uuid) {
    var _workInfo$total_finan, _workInfo$total_finan2, _workInfo$traffic_fin, _workInfo$traffic_fin2;
    var salaryNumber, total_financial_liabilitiesNumber, traffic_fine_valueNumber, params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          salaryNumber = typeof workInfo.salary === 'string' ? Number(workInfo.salary.replace(/,/g, '')) : workInfo.salary;
          total_financial_liabilitiesNumber = Number(workInfo === null || workInfo === void 0 ? void 0 : (_workInfo$total_finan = workInfo.total_financial_liabilities) === null || _workInfo$total_finan === void 0 ? void 0 : (_workInfo$total_finan2 = _workInfo$total_finan.toString()) === null || _workInfo$total_finan2 === void 0 ? void 0 : _workInfo$total_finan2.replace(/,/g, '')) || 0;
          traffic_fine_valueNumber = Number(workInfo === null || workInfo === void 0 ? void 0 : (_workInfo$traffic_fin = workInfo.traffic_fine_value) === null || _workInfo$traffic_fin === void 0 ? void 0 : (_workInfo$traffic_fin2 = _workInfo$traffic_fin.toString()) === null || _workInfo$traffic_fin2 === void 0 ? void 0 : _workInfo$traffic_fin2.replace(/,/g, '')) || 0;
          params = _objectSpread(_objectSpread({
            id: postId,
            post_id: postId,
            order_uuid: order_uuid
          }, workInfo), {}, {
            salary: salaryNumber,
            // this overwrites the original salary
            total_financial_liabilities: total_financial_liabilitiesNumber,
            traffic_fine_value: traffic_fine_valueNumber
          });
          _context.n = 1;
          return fetcher(null, true).post('/finance/create-arib-job-form', params);
        case 1:
          res = _context.v;
          return _context.a(2, res || null);
      }
    }, _callee);
  }));
  return function api__createArib(_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();
export default api__createArib;